import { useSelector } from 'react-redux'
import { selectDashboardPage } from 'redux/selectors/DashboardPage'
import { ApplicationState } from 'redux/Stores/types'

export const useEditMode = () => {
  return useSelector((state: ApplicationState) => {
    return selectDashboardPage(state).editMode
  })
}

export const useDashboardFilter = () => {
  return useSelector((state: ApplicationState) => {
    return selectDashboardPage(state).dashboardFilter
  })
}

export const usePeriodFilter = () => {
  return useSelector((state: ApplicationState) => {
    return selectDashboardPage(state).periodFilter
  })
}

export const useCustomSegmentByMapper = () => {
  return useSelector((state: ApplicationState) => {
    return selectDashboardPage(state).customSegmentByMapper
  })
}

export const useSavedDashboardFilter = () => {
  return useSelector((state: ApplicationState) => {
    return selectDashboardPage(state).savedDashboardFilter
  })
}

export const useToolbarOpen = () => {
  return useSelector((state: ApplicationState) => {
    const page = selectDashboardPage(state)

    return Boolean(page.periodFilter) || page.dashboardFilter.length > 0
  })
}
